import RSAA from "redux-api-middleware/es/RSAA";
import {defaultHeaders} from "../crud-actions";

export const types = {
    GALLERY_LIST: 'GALLERY_LIST',
    GALLERY_LIST_SUCCESS: 'GALLERY_LIST_SUCCESS',
    GALLERY_LIST_ERROR: 'GALLERY_LIST_ERROR',

    GALLERY_SELECT: 'GALLERY_SELECT',
    GALLERY_SELECT_SUCCESS: 'GALLERY_SELECT_SUCCESS',
    GALLERY_SELECT_ERROR: 'GALLERY_SELECT_ERROR',

    GALLERY_UPDATE: 'GALLERY_UPDATE',
    GALLERY_UPDATE_SUCCESS: 'GALLERY_UPDATE_SUCCESS',
    GALLERY_UPDATE_ERROR: 'GALLERY_UPDATE_ERROR',

    GALLERY_UPLOAD: 'GALLERY_UPLOAD',
    GALLERY_UPLOAD_SUCCESS: 'GALLERY_UPLOAD_SUCCESS',
    GALLERY_UPLOAD_ERROR: 'GALLERY_UPLOAD_ERROR',

    GALLERY_DESTROY: "GALLERY_DESTROY",
    GALLERY_DESTROY_SUCCESS: "GALLERY_DESTROY_SUCCESS",
    GALLERY_DESTROY_ERROR: "GALLERY_DESTROY_ERROR"
};

export const galleryLoad = (filter = {}) => {

    return {
        [RSAA]: {
            headers: defaultHeaders,
            endpoint: `${process.env.API_HOST}/api/v1/gallery/index`,
            method: 'POST',
            types: [
                { type: types.GALLERY_LIST, meta: { filter: filter }},
                { type: types.GALLERY_LIST_SUCCESS, meta: { filter: filter } },
                { type: types.GALLERY_LIST_ERROR, meta: { filter: filter } }
            ],
            credentials: 'same-origin',
            body: JSON.stringify(filter)
        },
        auth: true
    }

};

export const gallerySelect = (id) => {

    return {
        [RSAA]: {
            headers: defaultHeaders,
            endpoint: `${process.env.API_HOST}/api/v1/gallery/${id}`,
            method: 'POST',
            types: [
                types.GALLERY_SELECT,
                types.GALLERY_SELECT_SUCCESS,
                types.GALLERY_SELECT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    }

};


export const galleryUpdate = (id, data) => {

    const formData = new FormData();

    for ( const key in data ) {
        formData.append(`resource[${key}]`, data[key]);
    }

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/gallery/${id}`,
            method: 'PATCH',
            types: [
                types.GALLERY_UPDATE,
                types.GALLERY_UPDATE_SUCCESS,
                types.GALLERY_UPDATE_ERROR
            ],
            credentials: 'same-origin',
            body: formData
        },
        auth: true
    }

};

export const galleryUpload = (data) => {

    const formData = new FormData();

    for ( const key in data ) {
        formData.append(`resource[${key}]`, data[key]);
    }

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/gallery`,
            method: 'POST',
            types: [
                types.GALLERY_UPLOAD,
                types.GALLERY_UPLOAD_SUCCESS,
                types.GALLERY_UPLOAD_ERROR
            ],
            credentials: 'same-origin',
            body: formData
        },
        auth: true
    }

};

export const galleryDestroy = (id) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/gallery/${id}`,
            method: 'DELETE',
            types: [
                { type: types.GALLERY_DESTROY, meta: { id: id } },
                { type: types.GALLERY_DESTROY_SUCCESS, meta: { id: id } },
                { type: types.GALLERY_DESTROY_ERROR, meta: { id: id } }
            ],
            credentials: 'same-origin'
        },
        auth: true
    }

};
